/*
  TMA — motion.

  Three jobs, one file:

    1. the hero arrives on load, in reading order
    2. the three value-band stamps hop once, the first time they are seen
    3. everything else rises as it scrolls into view, staggering where it is
       a row or a list

  THE RULE THIS FILE OBEYS. Every element is visible and correctly placed with
  no JavaScript. The script adds the class that hides a thing and only then
  animates it back, so if it never runs — or IntersectionObserver is missing,
  or the reader prefers reduced motion — the page is simply already there.
  Motion is opt-in, never load-bearing.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* [container, child] — the container is watched, the children stagger.
     A container with no matching children just fades in as one piece. */
  var STAGGER = [
    ['.t26-hero__copy', ':scope > *'],
    ['.t26-band__in', '.t26-band__item'],
    ['.t26-line__grid', '.t26-pc'],
    ['.t26-steps__list', '.t26-steps__row'],
    ['.t26-hiw__list', '.t26-hiw__step'],
    ['.t26-offer__art--trio', 'img'],
    ['.t26-stock__list', '.t26-stock__item'],
    ['.t26-ig__grid', '.t26-ig__tile'],
    ['.t26-facts', '.t26-facts__card'],
    ['.t26-cmp__grid', ':scope > *']
  ];

  /* single blocks that just rise */
  var RISE = [
    '.t26-hero__art',
    '.t26-prose__card',
    '.t26-promise__card',
    '.t26-offer__copy',
    '.t26-quotes__card',
    '.t26-faq__card',
    '.t26-news__card',
    '.t26-cmp__card',
    '.t26-ctc__card',
    '.t26-banner__card'
  ];

  /* A phone is scrolled fast, and a section that only starts moving once it is
     already on screen finishes somewhere behind the thumb -- the motion gets
     spent where nobody is looking, which reads as a flicker rather than as
     content arriving. Starting a little before the element enters lets it
     settle into place as it comes up. Desktop scrolls more slowly and is
     better served by the original trigger, where the movement is actually
     watched. */
  var phone = window.matchMedia('(max-width: 767px)').matches;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('t26-rv--in');
      io.unobserve(entry.target);
    });
  }, phone
    ? { threshold: 0, rootMargin: '0px 0px 12% 0px' }
    : { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  function watch(el, immediate) {
    el.classList.add('t26-rv');
    if (!immediate) { io.observe(el); return; }

    /* Wait for a paint before releasing it. This script is deferred, so it
       runs before DOMContentLoaded finishes -- flipping the class here would
       let the whole transition complete during the first render and nobody
       would see it. Two frames guarantees the hidden state was painted once.
       setTimeout backs it up because rAF is throttled in background tabs, and
       a hero that never arrives is worse than one that arrives unanimated. */
    var released = false;
    function release() {
      if (released) return;
      released = true;
      el.classList.add('t26-rv--in');
    }
    requestAnimationFrame(function () { requestAnimationFrame(release); });
    setTimeout(release, 400);
  }

  STAGGER.forEach(function (pair) {
    document.querySelectorAll(pair[0]).forEach(function (container) {
      var kids = container.querySelectorAll(pair[1]);
      Array.prototype.forEach.call(kids, function (kid, i) {
        kid.style.setProperty('--rv-i', i);
      });
      container.classList.add('t26-rv-group');
      /* The hero is above the fold by definition, so it plays on load instead
         of waiting for a scroll that may never come. */
      watch(container, container.closest('.t26-hero') !== null);
    });
  });

  RISE.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      watch(el, el.closest('.t26-hero') !== null);
    });
  });
})();
